var map = {
	"./avatar-polly-base-full.png": 53306,
	"./avatar-polly-dino-full.png": 18063,
	"./avatar-polly-fall-full.png": 45954,
	"./avatar-polly-smoothie-full.png": 94487,
	"./avatar-polly-space-full.png": 17869,
	"./avatar-polly-spring-full.png": 90298,
	"./avatar-polly-summer-full.png": 1618,
	"./avatar-polly-winter-full.png": 65314
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12899;